const mtConf = typeof window === 'undefined' ? {} : window.mtConf

export default mtConf
